<template>
  <div>
    <main class="main-content">
      <div class="page-content">
        <div class="container">
          <div class="lds-ring" v-if="!isLoad">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
          <section class="geo-section geo-section--area geo-section--mountains" v-if="isLoad">
            <div class="page-title">
              <h2>Setting & Data | Mountains</h2>
            </div>
            <div class="geo-section__add">
              <div class="section-title">
                <h3>Add Mountain</h3>
              </div>
              <form action="javascript:void(0)" class="geo-section__area-form">
                <div class="form-control-group"><span class="form-control-label">Name</span>
                  <div :class="['form-control-wrap', { 'is-error' : error}]">
                    <input type="text" Placeholder="Title" @focus="error = false" v-model="title" class="form-control"/>
                  </div>
                  <!-- <span class="form-control-error-descr">Incorrect title</span> -->
                </div>

                <button type="submit" class="btn btn--green geo-section__location-form__submit"
                        @click="createMountainHandler"><span>Add</span></button>
              </form>
            </div>

            <div class="geo-section__area">
              <div class="section-title">
                <h3>Mountains</h3>
              </div>
              <div data-simplebar="data-simplebar" class="section-table-wrap">
                <div class="section-table section-table--geo section-table--mountains">

                  <div class="section-table__body">
                    <div class="section-table__row" v-for="(item, index) in mountains" :key="item.id">
                      <div class="col section-table__row__name-mount">
                        <div class="section-table__row__number">{{ index + 1 }}</div>
                        <div class="section-table__row__name">{{ item.title }}</div>
                      </div>
                      <div class="col col-actions">
                        <button type="button" class="btn btn--edit" @click="edit = {title : item.title, id: item.id}">
                          <svg width="1em" height="1em" class="icon icon-edit ">
                            <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-edit"></use>
                          </svg>
                        </button>
                        <button type="button" class="btn btn--remove" @click="$emit('deleteModalHandler', {
							  entity: 'Mountain',
							  name: item.title,
							  handler: deleteMountainHandler,
							  id: item.id
						  })">
                          <svg width="1em" height="1em" class="icon icon-close ">
                            <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
                          </svg>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </section>
        </div>
      </div>
    </main>
    <div class="modal-wrapper" v-if="edit">
      <div class="modal-backdrop"></div>
      <div class="modal-inner">
        <div class="edit-popup edit-popup--territory">
          <div class="edit-popup__header">
            <div class="edit-popup__title">
              <div class="edit-popup__title__icon">
                <svg width="1em" height="1em" class="icon icon-edit ">
                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-edit"></use>
                </svg>
              </div>
              <span>Edit  Mountain</span>
            </div>
            <div class="edit-popup__close" @click="isEdit ? $emit('notLeavePopupHandler', {
					  handler: clearEdit
				  }) : edit = null">
              <svg width="1em" height="1em" class="icon icon-close ">
                <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
              </svg>
            </div>
          </div>
          <form action="javascript:void(0)" class="edit-popup__inner">
            <div class="form-control-group">
              <div :class="['form-control-wrap', { 'is-error' : errorEdit}]">
                <input type="text" Placeholder="Title" @input="isEdit = true" @focus="errorEdit = false"
                       v-model="edit.title" class="form-control">
              </div>
            </div>
            <button type="submit" class="btn btn--green edit-popup__submit" @click="updateMountainHandler">
              <span>Save</span></button>
          </form>
        </div>
      </div>
    </div>

  </div>
</template>

<script>

import {
  getMountains,
  createMountain,
  updateMountain,
  deleteMountain
} from '@/utilites/api'

export default {
  data() {
    return {
      mountains: [],
      title: '',
      edit: null,
      isLoad: false,
      error: false,
      errorEdit: false,
      isEdit: false
    }
  },
  props: ['user', 'leavePopup'],
  beforeCreate() {
    document.title = 'Setting & Data / Mountains'
  },
  mounted() {
    document.title = 'Setting & Data / Mountains'
    this.updateData()
    window.addEventListener('click', event => {
      if (!event.target.closest('.edit-popup') && !event.target.closest('.btn')) {
        if (this.isEdit) {
          this.$emit('notLeavePopupHandler', {
            handler: this.clearEdit
          })
        } else {
          this.edit = false
        }

      }
    })
  },
  methods: {
    checkErrors() {
      this.error = /[^A-Za-z0-9\- ]/g.test(this.title.trim()) || this.title.trim().length === 0
    },
    checkErrorsEdit() {
      this.errorEdit = /[^A-Za-z0-9\- ]/g.test(this.edit.title.trim()) || this.edit.title.trim().length === 0
    },
    updateData() {
      this.isLoad = false
      getMountains(this.user.access_token)
          .then(res => {
            this.isLoad = true
            this.mountains = res
            this.title = ''
            this.edit = null
          })
    },
    createMountainHandler() {
      this.checkErrors()
      if (!this.error) {
        createMountain(this.user.access_token, {
          title: this.title
        })
            .then(() => {
              this.$emit('confirmed')
              this.updateData()
            })
      }
    },
    updateMountainHandler() {
      this.checkErrorsEdit()
      if (!this.errorEdit) {
        updateMountain(this.user.access_token, {
          id: this.edit.id,
          title: this.edit.title
        })
            .then(() => {
              this.$emit('confirmed')
              this.edit = null
              this.isEdit = false
              this.updateData()
            })
      }
    },
    deleteMountainHandler(id) {
      deleteMountain(this.user.access_token, id)
          .then(() => this.updateData())
    },
    clearEdit() {
      this.edit = null
      this.isEdit = false
    }
  }
}
</script>
